import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handlePost } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import ErrorAwareNumberField from '../../../../common/inputfields/ErrorAwareNumberField';
import ErrorAwareSelectField from '../../../../common/inputfields/ErrorAwareSelectField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import { calcBusinessDays, calcDays } from '../../../../common/filters/DateUtil'
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';

class NewVacationForDates extends Component {

    state = {
        selectedType: enums.vacationTypes[0],
        selectedEmployee: {},
        startDate: '',
        endDate: '',
        days: 1,
        errors: new Map(),
    }

    componentDidMount() {
        console.log(this.props);
        let d = 0;
        if (this.state.selectedType && this.state.selectedType.value !== 'GOV_PAID_SICK_LEAVE') {
            d = calcBusinessDays(new Date(this.props.start), new Date(this.props.end));
        } else {
            d = calcDays(new Date(this.props.start), new Date(this.props.end));
        }
        console.log(d);
        this.setState({ startDate: this.props.start, endDate: this.props.end, days: d })
    }

    handleTypeChangeEvent = (e) => {
        let d = 0;
        if (e.target.value.value !== 'GOV_PAID_SICK_LEAVE') {
            d = calcBusinessDays(new Date(this.state.startDate), new Date(this.state.endDate));
        } else {
            d = calcDays(new Date(this.state.startDate), new Date(this.state.endDate));
        }
        // console.log(d);
        this.setState({ days: d, selectedType: e.target.value })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/vacation';
        const requestObject = {
            "type": this.state.selectedType.value,
            "employeeId": this.state.selectedEmployee.value,
            "startDate": this.state.startDate,
            "endDate": this.state.endDate,
            "days": this.state.days,
        };
        handlePost(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        this.setState({ selectedEmployee: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            disabled={this.state.partnerDisabled}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareSelectField
                            labelId="type-label"
                            id="type"
                            name="selectedType"
                            label="Szabadság típusa"
                            errors={this.props.errors}
                            value={this.state.selectedType}
                            onChange={e => this.handleTypeChangeEvent(e)}
                            options={enums.vacationTypes}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="startDate"
                            label="Kezdés"
                            variant="outlined"
                            value={this.state.startDate}
                            errors={this.state.errors}
                            disabled />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="endDate"
                            label="Befejezés"
                            variant="outlined"
                            value={this.state.endDate}
                            errors={this.state.errors}
                            disabled />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="days"
                            label="Napok száma"
                            errors={this.state.errors}
                            value={this.state.days}
                            disabled />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewVacationForDates);
